/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubordinateIds } from './SubordinateIds';
import {
    SubordinateIdsFromJSON,
    SubordinateIdsFromJSONTyped,
    SubordinateIdsToJSON,
    SubordinateIdsToJSONTyped,
} from './SubordinateIds';

/**
 * 
 * @export
 * @interface ListSubordinatesResponse
 */
export interface ListSubordinatesResponse {
    /**
     * 
     * @type {SubordinateIds}
     * @memberof ListSubordinatesResponse
     */
    data: SubordinateIds;
}

/**
 * Check if a given object implements the ListSubordinatesResponse interface.
 */
export function instanceOfListSubordinatesResponse(value: object): value is ListSubordinatesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ListSubordinatesResponseFromJSON(json: any): ListSubordinatesResponse {
    return ListSubordinatesResponseFromJSONTyped(json, false);
}

export function ListSubordinatesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListSubordinatesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': SubordinateIdsFromJSON(json['data']),
    };
}

  export function ListSubordinatesResponseToJSON(json: any): ListSubordinatesResponse {
      return ListSubordinatesResponseToJSONTyped(json, false);
  }

  export function ListSubordinatesResponseToJSONTyped(value?: ListSubordinatesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': SubordinateIdsToJSON(value['data']),
    };
}

